import LearnPageLayout from "@/components/LearnPageLayout";
import { saintCost } from "./learnDataSaintCost";

/**
 * Static route wrapper for /learn/saint-tms-cost.
 */
const SaintCostPage = () => (
  <LearnPageLayout
    title={saintCost.title}
    description={saintCost.description}
    canonical={saintCost.canonical}
    h1={saintCost.h1}
    breadcrumbLabel={saintCost.breadcrumbLabel}
    crumbs={saintCost.crumbs}
    shortAnswer={saintCost.shortAnswer}
    keyTakeaways={saintCost.keyTakeaways}
    sections={saintCost.sections}
    faqs={saintCost.faqs}
    sources={saintCost.sources}
    schemaJson={saintCost.schemaJson}
    relatedLinks={saintCost.relatedLinks}
    reviewBlock={saintCost.reviewBlock}
  />
);

export default SaintCostPage;
